var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,13h2v6l-1,1H2l-1-1V4l1-1H6v2H3v13H21v-5Zm-1.29-11.71l-1.41,1.41,2.29,2.29H12l-.71,.29-4,4-.29,.71v4h2v-3.59l3.41-3.41h8.17l-2.29,2.29,1.41,1.41,4.29-4.29v-.83L19.71,1.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/1765206080/media/icon-share.8c04f1f1bfad7e801f6678f71f3f25dc.svg";
export { ForwardRef as ReactComponent };